export { default } from './bottomNavigation';
